import ControllerModal from './ControllerModal';

export default ControllerModal;
